import React from "react";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import { NavLink } from "react-router-dom";

type SidebarLinkProps = {
  label: string;
  link: string;
  activeIcon: React.ElementType;
  inactiveIcon: React.ElementType;
};

const sidebarVariants = cva(
  "p-1 flex flex-col items-center size-[66px] gap-1 text-xs justify-center rounded outline-none focus-visible:ring-4 focus-visible:ring-focus-input disabled:opacity-40 disabled:pointer-events-none transition duration-75 ",
  {
    variants: {
      variants: {
        active:
          "bg-tertiary text-brand-primary hover:bg-brand-primary-subtle hover:text-brand-primary-hover active:bg-tertiary active:text-brand-primary-pressed",
        inactive: "bg-transparent text-tertiary hover:text-tertiary-hover active:text-tertiary-pressed",
      },
    },
    defaultVariants: {
      variants: "inactive",
    },
  },
);

const InnerItem = ({ label, Icon }: { label: string; Icon: React.ElementType }) => {
  return (
    <>
      <Icon className="h-6 w-6" />
      <label className={"mx-auto max-w-full truncate"}>{label}</label>
    </>
  );
};

const SidebarLinkItem = ({ label, activeIcon, inactiveIcon, link }: SidebarLinkProps) => {
  return (
    <NavLink
      to={link}
      target={link.startsWith("http") ? "_blank" : undefined}
      title={label}
      className={({ isActive }) => clsx(sidebarVariants({ variants: isActive ? "active" : "inactive" }))}
    >
      {({ isActive }) => {
        const Icon = isActive ? activeIcon : inactiveIcon;
        return <InnerItem Icon={Icon} label={label} />;
      }}
    </NavLink>
  );
};

export default SidebarLinkItem;
